// extracted by mini-css-extract-plugin
export default {"btn":"styles_btn__7Otw3","fullWidth":"styles_fullWidth__dRcOj"};